import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SideNavButtonModel } from '../status-sidenav/side-nav.model';


@Component({
  moduleId: module.id,
  selector: 'status-sidenav-v2',
  templateUrl: 'status-sidenav-v2.component.html',
  styleUrls: ['status-sidenav-v2.component.scss'],
})
export class StatusSideNavV2Component {

  @Input() status: string;
  @Input() lastPublishedDate: string;
  @Input() timezone: string;
  @Input() showSaveBtn: boolean = false;
  @Input() showCloseBtn: boolean = false;
  @Input() showStatusButtons: boolean = false;
  @Input() saveEnabled: boolean = false;
  @Input() isDisabled: boolean = false; // disables any sidenav actions
  @Input() statusButtons: Array<SideNavButtonModel> = [];

  @Output() statusButtonClicked = new EventEmitter();
  @Output() closeClicked = new EventEmitter();
  @Output() saveClicked = new EventEmitter();

  get displayStatus(): string {
    return this.status || '';
  }

  onCloseClick() {
    this.closeClicked.emit();
  }

  onStatusButtonClick($event: SideNavButtonModel) {
    this.statusButtonClicked.emit($event.value);
  }

  onSaveButtonClick() {
    this.saveClicked.emit();
  }
}
